import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image, Label, Form, Transition } from 'semantic-ui-react';
import { userActions } from '../actions';
import Strings from './../common/Strings';
import { capitalize } from '../helpers/string';
import './Login.css';
import './Welcome.css';

class Welcome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
    };
  }

  submit = e => {
    e.preventDefault();

    const { firstName, lastName } = this.state;
    const { dispatch } = this.props;
    const user = {
      displayName: `${capitalize(firstName)} ${capitalize(lastName)}`,
    };
    dispatch(userActions.updateSettings(user, true));
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  renderError() {
    const visible = this.props.userError.length > 0;
    return (
      <Transition visible={visible} animation="fade" duration={500}>
        <Label id="error-text" className="error">
          {this.props.userError}
        </Label>
      </Transition>
    );
  }

  render() {
    const { firstName, lastName } = this.state;
    return (
      <div className="login">
        <div className="login-form">
          <Image id="app-logo" className="top-img" src="/logo-app.png" />
          <Form
            id="welcome-form"
            onSubmit={this.submit}
            loading={this.props.isUserLoading}
          >
            <Label id="welcome-info-text">{Strings.WELCOME.nameBrief}</Label>
            {this.renderError()}
            <Form.Input
              id="first-name-input"
              placeholder={Strings.WELCOME.firstNameHint}
              name="firstName"
              value={firstName}
              onChange={this.handleChange}
            />
            <Form.Input
              id="last-name-input"
              placeholder={Strings.WELCOME.lastNameHint}
              name="lastName"
              value={lastName}
              onChange={this.handleChange}
            />
            <Form.Button
              id="submit-button"
              className="button-green"
              content={Strings.WELCOME.getStarted}
              primary
              disabled={!firstName || !lastName}
            />
          </Form>
        </div>
      </div>
    );
  }
}

Welcome.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isUserLoading: PropTypes.bool,
  userError: PropTypes.string,
};

Welcome.defaultProps = {
  isUserLoading: false,
  userError: '',
};

const mapStateToProps = state => ({
  isUserLoading: state.uiState.isUserLoading,
  userError: state.uiState.userError,
});

export default connect(mapStateToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome.js